var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-all",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Menu",
    d: "M2,4.75A.75.75,0,0,1,2.75,4h10.5a.75.75,0,0,1,0,1.5H2.75A.75.75,0,0,1,2,4.75Zm0,7.5a.75.75,0,0,1,.75-.75H9.5a.75.75,0,0,1,0,1.5H2.75A.75.75,0,0,1,2,12.25Zm.75-4.5a.75.75,0,0,0,0,1.5h10.5a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-2 -4)",
    fill: "#333",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.7c419d0c3b7fb7a9f5fd0e9ce7c241d0.svg";
export { ForwardRef as ReactComponent };